<template>
    <div id="cardRateConfiguration" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemcategoriesHeader" v-if="$route.params.id > 0">Update Rate Configuration</span>
                    <span class="page-title" id="itemcategoriesHeader" v-else>Add Rate Cofiguration</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backHeaderList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content card-rate-config">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Contract Type:</label>
                                        <span class="col"> {{ contract_type }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Customer:</label>
                                        <span class="col"> {{ customer }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Scope:</label>
                                        <span class="col"> {{ scope }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Effective Date:</label>
                                        <span class="col"> {{ effective_date }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Expiry Date:</label>
                                        <span class="col"> {{ expiry_date }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row row-cols-md-4 row-cols-1 mb-4">
                                <div class="col form-group">
                                    <label class="control-label"  for="vehicle_type_id">Asset Type:</label>
                                    <!-- <input type="text" id="myInput" class="form-control" @input="filterFunction()" @blur="getSections()" placeholder="Search for Asset Type.."> -->
                                    <v-select v-model="vehicle_type_id" name="vehicle_type_id" @input="filterFunction()" placeholder="Select Vehicle Type."
                                            label="text"
                                            :options="vehicletypeArr">
                                    </v-select>
                                </div>
                            </div>
                            <div v-if="!disCheck && configResponse" class="btn-groups">
                                <button type="submit" id="createCardRate" class="btn btn-primary" v-on:click.prevent="createRateConfiguration" >
                                <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="cancelCardRate" class="btn btn-tertiary" v-on:click.prevent="backHeaderList" >
                                <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                            <div class="btn-groups badge-buttons text-left mb-3" v-if="configResponse">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getFixedConfig" :data-section="'FIXED'" v-on:click="fetchRateConfig(this,'fixed')" :class="'btn btn-secondary '+ fixed"> Fixed </button>
                                    <button type="button" id="getDistConfig" :data-section="'DIST'" v-on:click="fetchRateConfig(this,'dist')" :class="'btn btn-secondary '+ dist"> DIST </button>
                                    <button type="button" id="getReeferConfig" :data-section="'ELTSTB'" v-on:click="fetchRateConfig(this,'eltstb')" :class="'btn btn-secondary '+ eltstb"> ELTSTB / Electric StandBy</button>
                                    <button type="button" id="geteltsbconfig" :data-section="'ENHOUR'" v-on:click="fetchRateConfig(this,'enhour')" :class="'btn btn-secondary '+ enhour"> ENHOUR / Engine Hours </button>
                                    <button type="button" id="geteltsbconfig" :data-section="'RFHOUR'" v-on:click="fetchRateConfig(this,'rfhour')" :class="'btn btn-secondary '+ reefer"> RFHOUR / Reefer Hours </button>
                                </div>
                                <div v-if="idArr && idArr.length > 0">
                                    <div class="web-action-btn btn-groups text-right">
                                        <button type="button" id="rejectbtn" v-on:click="changeRateStatus('reject')" class="btn btn-primary pull-right"> Reject </button>

                                        <button type="button" id="approvebtn" v-on:click="changeRateStatus('approve')" class="btn btn-primary"> Approve</button>
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <span>Please wait while data is loading...</span>
                            </div>
                            <div v-if="fixed == 'active'" class="purchase-order-create-main form-group table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1" >
                                    <thead>
                                        <!-- <tr class="table-primary">
                                            <th v-if="disCheck">&nbsp;</th>
                                            <th scope="col" style="width:120px;"></th>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">&nbsp;</th>
                                            <th scope="col" style="text-align:right;">Day</th>
                                            <th scope="col" v-if="displayDis && base == 'true'">&nbsp;</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">&nbsp;</th>
                                            <th scope="col" style="text-align:right;">Week</th>
                                            <th scope="col" v-if="displayDis && base == 'true'">&nbsp;</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">&nbsp;</th>
                                            <th scope="col" style="text-align:right;">Month</th>
                                            <th scope="col" v-if="displayDis && base == 'true'">&nbsp;</th>
                                        </tr> -->
                                        <tr class="table-primary">
                                            <th v-if="disCheck"><label class="custome-checkbox">
                                                    <input type="checkbox" name="ratecheck" id="checkAll"
                                                        @input="saveAll($event)">
                                                    <span class="checkmark"></span>
                                                </label></th>
                                            <th scope="col" style="width:120px;">Equipment Type</th>
                                            <th scope="col">Section</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right" v-if="displayDis && base == 'true'">%Base</th>
                                            <th scope="col" class="text-right">Rate/Day</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right" v-if="displayDis && base == 'true'">%Base</th>
                                            <th scope="col" class="text-right">Rate/Week</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right" v-if="displayDis && base == 'true'">%Base</th>
                                            <th scope="col" class="text-right">Rate/Month</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable" v-if="rows && rows.length > 0">
                                        <tr v-for="(row, index) in rows" :key="index">
                                            <td v-if="disCheck">
                                                <label class="custome-checkbox">
                                                    <input type="checkbox" name="ratecheck"
                                                        @input="saveId($event,row)">
                                                    <span class="checkmark"></span>
                                                </label>
                                            <!-- <input type="checkbox" id="check" name="check" placeholder="Day Base Rate" @input="selectRates($event,index)" class="form-control"> -->
                                            </td>
                                            <td :data-id="row.truck_type_id">
                                                {{row.truck_type}}
                                            </td>
                                            <td>
                                                {{row.section}}
                                            </td>
                                            <td v-if="base == 'true'">
                                                <input type="text" v-model="row.day_base_rate" :disabled="true" id="day_base_rate" name="day_base_rate" placeholder="Day Base Rate" class="form-control text-right" @keypress="isNumber($event)">
                                                <br v-if="row.day_new_base && disCheck"/>
                                                <input type="text" v-if="row.day_new_base && disCheck" v-model="row.day_new_base" :disabled="true" id="day_new_base" name="day_new_base" placeholder="Day Base Rate" class="form-control text-right" @keypress="isNumber($event)">

                                                <!-- <div class="field-error">{{row.day_discount_error_msg}}</div> -->
                                            </td>
                                            <td v-if="displayDis && base == 'true'">
                                                <input type="text" v-model="row.day_discount" id="day_discount" name="day_discount" placeholder="Discount" @input="calculateDiscount($event,index,'day','dis')" class="form-control text-right" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.day_discount_error_msg}}</div> -->
                                                <br v-if="row.day_new_discount && disCheck"/>
                                                <input type="text" v-if="row.day_new_discount && disCheck" v-model="row.day_new_discount" :disabled="true" id="day_new_discount" name="day_new_discount" placeholder="Discount" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <td>
                                                <input type="text" placeholder="Rate" v-model="row.day_rate" name="day_rate" @keypress="isNumber($event)" @input="calculateDiscount($event,index,'day','rate')" id="quantity" class="form-control text-right">
                                                <!-- <div class="field-error">{{row.day_rate_error_msg}}</div> -->
                                                <br v-if="row.day_new_rate && disCheck"/>
                                                <input type="text" v-if="row.day_new_rate && disCheck" v-model="row.day_new_rate" :disabled="true" id="day_new_rate" name="day_new_rate" placeholder="Discount" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-show="row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC' && base == 'true'"> -->
                                            <td v-show="base == 'true'">
                                                <input type="text" v-model="row.week_base_rate" :disabled="true" id="week_base_rate" name="week_base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'week','dis')" class="form-control text-right" @keypress="isNumber($event)">
                                                <div class="field-error">{{row.week_base_rate_error_msg}}</div>

                                                <br v-if="row.week_new_base && disCheck"/>
                                                <input type="text" v-if="row.week_new_base && disCheck" v-model="row.week_new_base" :disabled="true" id="week_new_base" name="week_new_base" placeholder="Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-if="displayDis && row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC' && base == 'true'"> -->
                                            <td v-if="displayDis && base == 'true'">
                                                <input type="text" v-model="row.week_discount" id="week_discount" name="week_discount" placeholder="Discount" class="form-control text-right" @input="calculateDiscount($event,index,'week','dis')" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.week_discount_error_msg}}</div> -->
                                                <br v-if="row.week_new_discount && disCheck"/>
                                                <input type="text" v-if="row.week_new_discount && disCheck" v-model="row.week_new_discount" :disabled="true" id="week_new_discount" name="week_new_discount" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-show="row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC'"> -->
                                            <td>
                                                <input type="text" placeholder="Rate" v-model="row.week_rate" name="week_rate" @keypress="isNumber($event)" id="quantity" @input="calculateDiscount($event,index,'week','rate')" class="form-control text-right">
                                                <!-- <div class="field-error">{{row.week_rate_error_msg}}</div> -->
                                                <br v-if="row.week_new_rate && disCheck"/>
                                                <input type="text" v-if="row.week_new_rate && disCheck" v-model="row.week_new_rate" :disabled="true" id="week_new_rate" name="week_new_rate" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-show="row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC' && base == 'true'"> -->
                                            <td v-show="base == 'true'">
                                                <input type="text" v-model="row.month_base_rate" :disabled="true" id="month_base_rate" name="month_base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'month','dis')" class="form-control text-right" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.month_discount_error_msg}}</div> -->
                                                <br v-if="row.month_new_base && disCheck"/>
                                                <input type="text" v-if="row.month_new_base && disCheck" v-model="row.month_new_base" :disabled="true" id="month_new_base" name="month_new_base" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-if="displayDis && row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC' && base == 'true'"> -->
                                            <td v-if="displayDis && base == 'true'">
                                                <input type="text" v-model="row.month_discount" id="month_discount" name="month_discount" placeholder="Discount" @input="calculateDiscount($event,index,'month','dis')" class="form-control text-right" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.month_discount_error_msg}}</div> -->
                                                <br v-if="row.month_new_discount && disCheck"/>
                                                <input type="text" v-if="row.month_new_discount && disCheck" v-model="row.month_new_discount" :disabled="true" id="month_new_discount" name="month_new_discount" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <!-- <td v-show="row.section != 'INSPD' && row.section != 'INSPL' && row.section != 'ENV' && row.section != 'LIC'"> -->
                                            <td>
                                                <input type="text" placeholder="Rate" v-model="row.month_rate" name="month_rate" @input="calculateDiscount($event,index,'month','rate')" @keypress="isNumber($event)" id="quantity" class="form-control text-right">
                                                <!-- <div class="field-error">{{row.month_rate_error_msg}}</div> -->
                                                <br v-if="row.month_new_rate && disCheck"/>
                                                <input type="text" v-if="row.month_new_rate && disCheck" v-model="row.month_new_rate" :disabled="true" id="month_new_rate" name="month_new_rate" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody id="myTable" v-else>
                                        No Record Found
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="purchase-order-create-main form-group table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <!-- <tr class="table-primary">
                                            <th v-if="disCheck">&nbsp;</th>
                                            <th scope="col" style="width:120px;"></th>
                                            <th scope="col">&nbsp;</th>
                                            <th v-if="base == 'true'" scope="col" style="border-left:2px solid white;">&nbsp;</th>
                                            <th scope="col" class="text-right" v-if="dist == 'active'">Mile</th>
                                            <th scope="col" class="text-right" v-else>Hour</th>
                                            <th scope="col" v-if="displayDis && base == 'true'">&nbsp;</th>
                                        </tr> -->
                                        <tr class="table-primary">
                                            <th v-if="disCheck"><label class="custome-checkbox">
                                                    <input type="checkbox" name="ratecheck" id="checkAll"
                                                        @input="saveAll($event)">
                                                    <span class="checkmark"></span>
                                                </label></th>
                                            <th scope="col" style="width:120px;">Equipment Type</th>
                                            <th scope="col">Section</th>
                                            <th v-if="base == 'true'" scope="col" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right" v-if="displayDis && base == 'true'">%Base</th>
                                            <th scope="col" class="text-right" v-if="dist == 'active'">Rate/Mile</th>
                                            <th scope="col" class="text-right" v-else>Rate/Hour</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable" v-if="rows && rows.length > 0">
                                        <tr v-for="(row, index) in rows" :key="index">
                                             <td v-if="disCheck">
                                                <label class="custome-checkbox">
                                                    <input type="checkbox" name="ratecheck" id="rateCheck"
                                                        @change="saveId($event,row)">
                                                    <span class="checkmark"></span>
                                                </label>
                                            <!-- <input type="checkbox" id="check" name="check" placeholder="Day Base Rate" @input="selectRates($event,index)" class="form-control"> -->
                                            </td>
                                            <td :data-id="row.truck_type_id">
                                                {{row.truck_type}}
                                            </td>
                                            <td>
                                                {{row.section}}
                                            </td>
                                            <td v-if="base == 'true'">
                                                <input type="text" v-model="row.base_rate" :disabled="displayDis" id="base_rate" name="base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'variable','dis')" class="form-control text-right" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.day_discount_error_msg}}</div> -->
                                                <br v-if="row.new_base && disCheck"/>
                                                <input type="text" v-if="row.new_base && disCheck" v-model="row.new_base" :disabled="true" id="new_base" name="new_base" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <td v-if="displayDis && base == 'true'">
                                                <input type="text" v-model="row.discount" id="discount" name="discount" placeholder="Discount" class="form-control text-right" @input="calculateDiscount($event,index,'variable','dis')" @keypress="isNumber($event)">
                                                <!-- <div class="field-error">{{row.day_discount_error_msg}}</div> -->
                                                <br v-if="row.new_discount && disCheck"/>
                                                <input type="text" v-if="row.new_discount && disCheck" v-model="row.new_discount" :disabled="true" id="new_discount" name="new_discount" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                            <td>
                                                <input type="text" placeholder="Rate" v-model="row.rate" name="rate" @keypress="isNumber($event)" @input="calculateDiscount($event,index,'variable','rate')" id="rate" class="form-control text-right">
                                                <!-- <div class="field-error">{{row.day_rate_error_msg}}</div> -->
                                                <br v-if="row.new_rate && disCheck"/>
                                                <input type="text" v-if="row.new_rate && disCheck" v-model="row.new_rate" :disabled="true" id="new_rate" name="new_rate" placeholder="Week Base" class="form-control text-right" @keypress="isNumber($event)">

                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody id="myTable" v-else>
                                        No Record Found
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="!disCheck" class="btn-groups">
                                <button type="submit" id="createCardRate" class="btn btn-primary" v-on:click.prevent="createRateConfiguration" >
                                <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="cancelCardRate" class="btn btn-tertiary" v-on:click.prevent="backHeaderList" >
                                <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "cardRateConfiguration",

  metaInfo() {
      return {title: "Card Rate Configuration | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins, contractMixins],
  data: () => ({
    vehicle_type_id: null,
    vehicleTypeArr:[],
    permissions: [],
    cantAccessPage: "",
    contract_type: "",
    scope: "",
    effective_date: "",
    loading:false,
    expiry_date: "",
    customer: "",
    rows:[],
    fixed:'',
    dist:'',
    eltstb:'',
    enhour:'',
    reefer:'',
    displayDis:true,
    idArr:[],
    base:'true',
    disCheck:false,
    activeFlag:'fixed',
    truckTypes: "",
    billing_frequency: "",
    configResponse:false,
    currentAssetType:0
  }),
  created: function() {

  },
  watch:{
      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'scope_rate_configuration') {
                      self.cantAccessPage = true;

                  }
              }
          }

      }
  },
  mounted: function() {

        var self = this;
        self.getPermissions();
        // self.loadFieldData(['vehicleType']);
        var path = window.location.pathname;
        var segments = path.split("/");
        // if (self.$route.query.from == 'customer'){
        //     self.displayDis = true;
        // }
        if (self.$route.query.from == 'status'){
            self.disCheck = true;
        }
        if (segments[3]) {
            self.loadScopeHeader();
            setTimeout(function(){
            self.fetchRateConfig('','fixed');
            },1000);
        }

        self.loadAssetTypeForRental();
  },
  methods: {
      loadAssetTypeForRental() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/rentalagreement/search",
           type: "GET",
            headers: this.ajxHeaders,
            data:{
                // params:['rentalVehicleType']
                params:['vehicleType']
            },
            crossDomain: true,
            dataType: 'json',
            success: function (data) {
                console.log("rental agreement")
                console.log(data)
                if (data.status == "success") {
                    self.vehicletypeArr = data.AssetType;
                    if (self.vehicletypeArr != null){
                        self.vehicle_type_id = self.vehicletypeArr[0];
                    }
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'load-rental-agreement-search')
            }
        });
    },
    filterFunction: function() {
        // Declare variables
        var self = this;
        var input, filter, mytable, tr, td, i, txtValue;
        // input = document.getElementById('myInput');
        // filter = input.value.toUpperCase();
        if (self.vehicle_type_id != null && self.vehicle_type_id.vtCode){
            filter = self.vehicle_type_id.vtCode;
            //console.log(input);
            mytable = document.getElementById("myTable");
            tr = mytable.getElementsByTagName('tr');
            //console.log("mytr: "+tr.length);

            var notFoundCount = 0;
            //remove no record found element
            var removeElement = document.getElementById("noRecordFound");
            if (removeElement != undefined && removeElement != null) {
                removeElement.parentNode.removeChild(removeElement);
            }
            var tpid = 0;
                // Loop through all list items, and hide those who don't match the search query
            for (i = 0; i < tr.length; i++) {
            if(this.disCheck == true){
                td = tr[i].getElementsByTagName("td")[1];
            } else {
                td = tr[i].getElementsByTagName("td")[0];
            }

            // console.log(tr[1].getElementsByTagName("td")[0]);
                txtValue = td.textContent || td.innerText;
                if (txtValue != "No Record Found.") {
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        tr[i].style.display = "";
                        // tpid = $(td).attr("data-id");
                    } else {
                        tr[i].style.display = "none";
                        notFoundCount++;
                    }
                }
            }
            //append no record found element
            if (notFoundCount == tr.length) {
                var notFoundElement = document.getElementById("noRecordFound");
                var notFound = document.createElement("tr");
                var notFoundLink = document.createElement("td");
                notFoundLink.innerHTML = "No Record Found.";
                notFound.setAttribute("id", "noRecordFound");
                notFound.appendChild(notFoundLink);
                mytable.appendChild(notFound);
            }
        }

        self.getSections();
    },
    backHeaderList() {
      var self = this;
      self.$router.push("/scope-header/list");
    },
    calculateDiscount:function(evt,index,flag,from){
        var self = this;
        // console.log(self.rows[index].discount);
        if (flag == 'day'){
            if (from == 'rate'){
                if (self.rows[index].day_rate && self.rows[index].day_base_rate){

                    var total = (self.rows[index].day_rate / self.rows[index].day_base_rate) * 100;

                    self.rows[index].day_discount = total.toFixed(2);

                }else{
                    self.rows[index].day_discount = '';
                }
            }else{
                if (self.rows[index].day_discount && self.rows[index].day_base_rate){

                    var total = (self.rows[index].day_discount * self.rows[index].day_base_rate) / 100;

                    self.rows[index].day_rate = total.toFixed(2);

                }else{
                    self.rows[index].day_rate = self.rows[index].day_base_rate;
                }
            }

        }else if(flag == 'week'){
            if (from == 'rate'){
                if (self.rows[index].week_rate && self.rows[index].week_base_rate){

                    var total = (self.rows[index].week_rate / self.rows[index].week_base_rate) * 100;

                    self.rows[index].week_discount = total.toFixed(2);

                }else{
                    self.rows[index].week_discount = '';
                }
            }else{
                if (self.rows[index].week_discount && self.rows[index].week_base_rate){

                var total = (self.rows[index].week_discount * self.rows[index].week_base_rate) / 100;

                self.rows[index].week_rate = total.toFixed(2);

                }else{
                    self.rows[index].week_rate = self.rows[index].week_base_rate;
                }
            }
        }else if(flag == 'month'){
            if (from == 'rate'){
                if (self.rows[index].month_rate && self.rows[index].month_base_rate){

                    var total = (self.rows[index].month_rate / self.rows[index].month_base_rate) * 100;

                    self.rows[index].month_discount = total.toFixed(2);

                }else{
                    self.rows[index].month_discount = '';
                }
            }else{
                if (self.rows[index].month_discount && self.rows[index].month_base_rate){

                var total = (self.rows[index].month_discount * self.rows[index].month_base_rate) / 100;

                self.rows[index].month_rate = total.toFixed(2);

                }else{
                    self.rows[index].month_rate = self.rows[index].month_base_rate;
                }
            }
        }else if(flag == 'variable'){
            if (from == 'rate'){
                if (self.rows[index].rate && self.rows[index].base_rate){

                    var total = (self.rows[index].rate / self.rows[index].base_rate) * 100;

                    self.rows[index].discount = total.toFixed(2);

                }else{
                    self.rows[index].discount = '';
                }
            }else{
                if (self.rows[index].discount && self.rows[index].base_rate){

                var total = (self.rows[index].discount * self.rows[index].base_rate) / 100;

                self.rows[index].rate = total.toFixed(2);

                }else{
                    self.rows[index].rate = self.rows[index].base_rate;
                }
            }
        }
        // if (flag == 'discount'){
        //     if (self.rows[index].discount > 0){
        //         // self.rows[index].reason = 'ACCOM';
        //         self.rows[index].reason = {text:'Customer Accomodation',value:'ACCOM'}
        //     }else{
        //         self.rows[index].reason = '';
        //     }
        // }
    },
    fetchRateConfig:function(evt,flag){
        var self = this;
        self.fixed = '';
        self.dist = '';
        self.eltstb = '';
        self.enhour = '';
        self.reefer = '';

        self.activeFlag = flag;

        if (flag == 'fixed'){
            self.fixed = 'active';
            self.loadScopeRates('fixed');
        }else if(flag == 'dist'){
            self.dist = 'active';
            self.loadScopeRates('dist');
        }else if(flag == 'eltstb'){
            self.eltstb = 'active';
            self.loadScopeRates('eltstb');
        }else if(flag == 'enhour'){
            self.enhour = 'active';
            self.loadScopeRates('enhour');
        }else if(flag == 'rfhour'){
            self.reefer = 'active';
            self.loadScopeRates('rfhour');
        }
    },
    loadScopeHeader() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/card-rate-header/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                if (data.status == "success") {

                    self.contract_type = data.content.contract_type;
                    // self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.customer)};
                    self.effective_date = data.content.effective_date;
                    self.expiry_date = data.content.expiry_date;
                    self.customer = self.titleCase(data.content.map_type);
                    self.scope = data.content.scope;
                    self.billing_frequency = data.content.billing_frequency;
                    self.loading = false;
                } else {
                  self.loading = false;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
            }
        });
    },

    createRateConfiguration() {

        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        var error = true;
        $("#createCardRate").val("Updating ...");
        $("#createCardRate").prop("disabled", true);
        $("#cancelCardRate").prop("disabled",true);

        for(var i = 0;i < self.rows.length;i++){
            console.log(self.rows[i]);
            if ((self.rows[i].day_rate != '' && self.rows[i].day_rate > 0) || (self.rows[i].week_rate != '' && self.rows[i].week_rate > 0) || (self.rows[i].month_rate != '' && self.rows[i].month_rate > 0) || (self.rows[i].rate != '' && self.rows[i].rate > 0)){
                error = false;
            }
        }

        if (error){
            self.$swal('','Please add atleast one rate','info');
            return;
        }

        var isYesToshow = false;


        if(self.billing_frequency == 'weekly') {
          self.$swal({
                title: 'Do you want to update active agreement rate?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
          }).then((result) => {

              if (result.value) {
                console.log(result.value);
                isYesToshow = true;
              } else {
                console.log("no");
              }

              var fields = [];
              fields.push({ name: "id", value: segments[3] });
              fields.push({ name: "rates", value: JSON.stringify(self.rows)});
              self.loading = true;

              $.ajax({
                  url: process.env.ROOT_API + "/card-rates/create",
                  type: "POST",
                  data: fields,
                  headers: this.ajxHeaders,
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;
                      $("#createCardRate").val("Update");
                      $("#createCardRate").prop("disabled", false);
                      $("#cancelCardRate").prop("disabled",false);

                      if (data.status == "success") {

                        self.truckTypes = "";

                          self.truckTypes = data.content.truck_type.toString();
                          var sections = data.content.sections.toString();
                          if(isYesToshow && self.truckTypes != "") {
                            self.$router.push('/agreement/scope/'+segments[3] + "?type=" + btoa(self.truckTypes) + "&section=" + btoa(sections));
                          }

                          // self.$router.push("/scope-header/list");
                          self.$swal('','Rate Stored Successfully','success');
                          self.loadScopeRates(self.activeFlag);

                      } else {
                          if (data.content.length > 0) {
                              var err = "";
                              for (var i = 0; i < data.content.length; i++) {
                                  err += data.content[i] + "<br>";
                              }
                              $("#errorMsg").html(err);
                              $(".alert-warning").toggleClass("show");
                              setTimeout(function () {
                                  $(".alert-warning").removeClass("show");
                                  $(".alert-warning").addClass("hide");
                              }, 10000);
                          }
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      $("#createCardRate").val("Update");
                      $("#createCardRate").prop("disabled", false);
                      $("#cancelCardRate").prop("disabled",false);
                      self.generateStatusCodeMessage(jqXHR,true,'comp-cate-create')
                  }
              });
          });

        } else {

          var fields = [];
          fields.push({ name: "id", value: segments[3] });
          fields.push({ name: "rates", value: JSON.stringify(self.rows)});
          self.loading = true;

          $.ajax({
                  url: process.env.ROOT_API + "/card-rates/create",
                  type: "POST",
                  data: fields,
                  headers: this.ajxHeaders,
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;
                      $("#createCardRate").val("Update");
                      $("#createCardRate").prop("disabled", false);
                      $("#cancelCardRate").prop("disabled",false);

                      if (data.status == "success") {
                          self.$swal('','Rate Stored Successfully','success');
                          self.loadScopeRates(self.activeFlag);
                      } else {
                          if (data.content.length > 0) {
                              var err = "";
                              for (var i = 0; i < data.content.length; i++) {
                                  err += data.content[i] + "<br>";
                              }
                              $("#errorMsg").html(err);
                              $(".alert-warning").toggleClass("show");
                              setTimeout(function () {
                                  $(".alert-warning").removeClass("show");
                                  $(".alert-warning").addClass("hide");
                              }, 10000);
                          }
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      $("#createCardRate").val("Update");
                      $("#createCardRate").prop("disabled", false);
                      $("#cancelCardRate").prop("disabled",false);
                      self.generateStatusCodeMessage(jqXHR,true,'comp-cate-create')
                  }
              });

        }
    },

    loadScopeRates(flag) {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;

        var status = '';
        if (self.disCheck == true){
            status = 'pending';
        }

        $.ajax({
            url: process.env.ROOT_API + "/card-rates/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                flag:flag,
                status:status,

            },
            success: function (data) {
                self.configResponse = true;

                if (data.status == "success") {

                    self.base = data.content.base;
                    self.rows = data.content.content;
                     setTimeout(function(){
                      self.loading = false;
                      self.filterFunction();
                    },350);

                } else {
                  self.loading = false;
                }


            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.configResponse = true;
                self.generateStatusCodeMessage(jqXHR,false,'card-rate-by-id')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    saveId(evt,obj){
        var self = this;
        console.log(obj);
        if (obj.day_new_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.day_new_id});
            }else{
                var i = self.idArr.indexOf(obj.day_new_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.day_new_id
                })
                self.idArr = filteredItems;
            }
        }else if (obj.day_rate_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.day_rate_id});
            }else{
                var i = self.idArr.indexOf(obj.day_rate_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.day_rate_id
                })
                self.idArr = filteredItems;
            }
        }
        if (obj.week_new_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.week_new_id});
            }else{
                var i = self.idArr.indexOf(obj.week_new_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.week_new_id
                })
                self.idArr = filteredItems;
            }
        }else if (obj.week_rate_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.week_rate_id});
            }else{
                var i = self.idArr.indexOf(obj.week_rate_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.week_rate_id
                })
                self.idArr = filteredItems;
            }
        }
        if (obj.month_new_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.month_new_id});
            }else{
                var i = self.idArr.indexOf(obj.month_new_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.month_new_id
                })
                self.idArr = filteredItems;
            }
        }else if(obj.month_rate_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.month_rate_id});
            }else{
                var i = self.idArr.indexOf(obj.month_rate_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.month_rate_id
                })
                self.idArr = filteredItems;
            }
        }
        if (obj.new_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.new_id});
            }else{
                var i = self.idArr.indexOf(obj.new_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.new_id
                })
                self.idArr = filteredItems;
            }
        }else if(obj.rate_id){
            if(evt.target.checked == true){
                self.idArr.push({id:obj.rate_id});
            }else{
                var i = self.idArr.indexOf(obj.rate_id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== obj.rate_id
                })
                self.idArr = filteredItems;
            }
        }

        console.log(self.idArr);
    },
    changeRateStatus:function(flag){
        var self = this;
        var isYesToshow = false;

        var path = window.location.pathname;
        var segments = path.split("/");

        self.$swal({
                title: 'Do you want to update active agreement rate?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
          }).then((result) => {

              if (result.value) {
                console.log(result.value);
                isYesToshow = true;
              } else {
                console.log("no");
              }

              self.loading = true;
              $.ajax({
                  url: process.env.ROOT_API + "/card-rates-status/change",
                  type: "POST",
                  headers: this.ajxHeaders,
                  dataType: "json",
                  data:{
                      flag:flag,
                      idArr:self.idArr
                  },
                  success: function (data) {
                      self.loading = false;
                      if (data.status == "success") {
                          self.loadScopeRates('fixed');
                          $("input:checkbox").prop('checked',false);

                          self.truckTypes = "";
                          self.truckTypes = data.content.truck_type.toString();
                          var sections = data.content.sections.toString();
                          if(isYesToshow && self.truckTypes != "") {
                            self.$router.push('/agreement/scope/'+segments[3] + "?type=" + btoa(self.truckTypes) + "&section=" + btoa(sections));
                          }
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      self.generateStatusCodeMessage(jqXHR,false,'card-rates-status-change')
                  }
              });
          });
    },
    saveAll:function(evt){
        var self = this;
        $("#checkAll").change(function () {
            $("input:checkbox").prop('checked', $(this).prop("checked"));
        });

        if (evt.target.checked == true){
            for (var i = 0; i < self.rows.length; i++) {
                var obj = self.rows[i];
                if (obj.day_new_id){
                    self.idArr.push({id:obj.day_new_id});
                }else if (obj.day_rate_id){
                    self.idArr.push({id:obj.day_rate_id});
                }
                if (obj.week_new_id){
                    self.idArr.push({id:obj.week_new_id});

                }else if (obj.week_rate_id){
                    self.idArr.push({id:obj.week_rate_id});
                }
                if (obj.month_new_id){
                    self.idArr.push({id:obj.month_new_id});
                }else if(obj.month_rate_id){
                    self.idArr.push({id:obj.month_rate_id});
                }
                if (obj.new_id){
                    self.idArr.push({id:obj.new_id});
                }else if(obj.rate_id){
                    self.idArr.push({id:obj.rate_id});
                }
            }
            console.log(self.idArr);
        }else{
            self.idArr = [];
        }
    },
    getSections:function(){
        var self = this;
        var truckId = 0;

        if (self.vehicle_type_id == null || !self.vehicle_type_id.value){
            return;
        }
        $.ajax({
            url: process.env.ROOT_API + "/get-section",
            type: "GET",
            headers: this.ajxHeaders,
            data: {
                truck_type:self.vehicle_type_id.value,
                agreementId:0,
                vehicle_id:0,
                // rental_type:self.osrSelection
            },
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    console.log(data.content);
                    // self.unitArr = data.content;
                    // self.readInArr = data.content;
                    // if (data.content.length > 0){
                    //     console.log(data.content);
                    // }
                    var secArr = [];
                    var sectionArr = data.content;

                    if (sectionArr.length > 0){
                         for (var i = 0; i < sectionArr.length; i++) {
                            // var secName = $(button[i]).attr("data-section");
                            secArr.push(sectionArr[i].section);
                        }
                    }

                    if (secArr.length > 0){
                        var div = document.getElementById("divTabMenu");
                        var button = div.getElementsByTagName('button');

                         for (var j = 0; j < button.length; j++) {
                            var secName = $(button[j]).attr("data-section");

                            if (secName != 'FIXED'){
                                if (!secArr.includes(secName)){
                                    button[j].style.display = "none";
                                }else{
                                    button[j].style.display = "block";
                                }
                            }
                        }
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-po')
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CardRateConfiguration.vue